import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';
import { NgxPrintModule } from 'ngx-print';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { StoreModule } from '@ngrx/store';
import { IncidentRoutingModule } from './incident-routing.module';
import { IncidentComponent } from './components/incident/incident.component';
import { IncidentContainerComponent } from './containers/incident-container.component';
import { GatewayFacade } from "libs/gateway/src/lib/states/+gateway/gateway.facades";
import { IncidentFacade } from './states/incident.facade';
import * as incidentReducer from "./states/incident.reducer";
import * as gatewayreducer from "libs/gateway/src/lib/states/+gateway/gateway.reducer"
import { EffectsModule } from '@ngrx/effects';
import {IncidentEffects} from './states/incident.effects';
import { IncidentSearchComponent } from './components/incident/search/incidentsearch.component';
import { IncidentListComponent } from './components/incident/incident-list/incident-list.component';
import { AreaOfImpactComponent } from './components/incident/areaofimpact/areaofimpact.component';
import { ImpactedCommunityComponent } from './components/incident/impactedcommunity/impactedcommunity.component';
import { AddressBookComponent } from './components/incident/address-book/address-book.component';
import { AddressBookListComponent } from './components/incident/address-book/address-book-list/address-book-list.component';
import {AddressBookSearchComponent} from './components/incident/address-book/address-book-search/address-book-search.component'
import { AcquisitionGenericEffects } from "./states/+acquisition-generic/acquisition-generic.effects";
import { AcquisitionGenericFacade } from "./states/+acquisition-generic/acquisition-generic.facade";
import * as acquisitionGenericReducer from "./states/+acquisition-generic/acquisition-generic.reducer";
import { PaymentModule } from '../../../payment/src/lib/payment.module';
import { ImpactedAssetComponent } from './components/incident/impactedasset/impactedasset.component';
import { IncidentassetpopupSearchComponent } from './components/incidentassetpopup/incidentassetpopup-search/incidentassetpopup-search.component';
import { IncidentassetpopupListComponent } from './components/incidentassetpopup/incidentassetpopup-list/incidentassetpopup-list.component';
import { IncidentassetpopupComponent } from './components/incidentassetpopup/incidentassetpopup.component';
import * as pipelineGenericReducer from "./states/+pipeline-generic/pipeline-generic.reducer";
import { PipelineGenericFacade } from './states/+pipeline-generic/pipeline-generic.facade';
import { AreaMapOfSpillComponent } from './components/incident/area-map-of-spill/area-map-of-spill.component';
import { ViewAreaMapOfSpillComponent } from './components/incident/view-area-map-of-spill/view-area-map-of-spill.component';
import { ExcelDocumentRightUploadViewComponent } from './components/incident/document/document-table/excel-document-upload-view/excel-document-upload-view.component';
import { DocumentRightTableComponent } from './components/incident/document/document-table/document-table.component';
import { DocumentRightComponent } from './components/incident/document/document.component';
import { DocumentFacade } from '../../../generic-document/src/lib/document-states/document.facade';


@NgModule({
  imports: [
CommonModule,
    RouterModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    IncidentRoutingModule,
    PaymentModule,
    NgxPrintModule,
    StoreModule.forFeature(
      incidentReducer.INCIDENT_FEATURE_KEY,
      incidentReducer.reducer,
    ),
    StoreModule.forFeature(
      gatewayreducer.Gateway_FEATURE_KEY_AreaOfImpact,
      gatewayreducer.areaofimpactreducer,
    ),
    StoreModule.forFeature(
      gatewayreducer.Gateway_FEATURE_KEY_ImpactedAsset,
      gatewayreducer.impactedassetreducer,
    ),
    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_FEATURE_KEY,
      acquisitionGenericReducer.reducer,
    ),
    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_PIPELINE_ASSET_LINK_FEATURE_KEY,
      pipelineGenericReducer.pipelineAssetReducer,
    ),

    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_LAND_TITLE_FEATURE_KEY,
      pipelineGenericReducer.landTitleReducer,
    ),


    StoreModule.forFeature(
      acquisitionGenericReducer.ACQUISITION_GENERIC_ADDRESS_BOOK_FEATURE_KEY,
      acquisitionGenericReducer.addressBookReducer,
    ),
    EffectsModule.forFeature([
      IncidentEffects,
      AcquisitionGenericEffects,
    ])
  ],
  providers: [
    DocumentFacade,
    IncidentFacade,
    GatewayFacade,
    AcquisitionGenericFacade,
    PipelineGenericFacade
  ],
  declarations: [
    IncidentComponent,
    IncidentContainerComponent,
    IncidentSearchComponent,
    IncidentListComponent,
    AreaOfImpactComponent,
    ImpactedCommunityComponent,
    AddressBookComponent,
    AddressBookListComponent,
    AddressBookSearchComponent,
    ImpactedAssetComponent,
    IncidentassetpopupSearchComponent,
    IncidentassetpopupListComponent,
    IncidentassetpopupComponent,
    AreaMapOfSpillComponent,
    ViewAreaMapOfSpillComponent,
    ExcelDocumentRightUploadViewComponent,
    DocumentRightTableComponent,
    DocumentRightComponent
  ],
})
export class IncidentModule {}
